export default "__VITE_ASSET__2fd87f48__"